import EcoSpace from 'eco-design/base/eco-space';
import BannerA from '../../components/BannerA';
import BannerA1 from '../../components/BannerA1';
import EcoAi from '../../components/EcoAi';
import Engineering from '../../components/Engineering';
import FooterTcA from '../../components/FooterTcA';
import OnlineStoreRightsA from '../../components/OnlineStoreRightsA3';
import OnlineStoreRightsA4 from '../../components/OnlineStoreRightsA4';
import PathToZero from '../../components/PathToZero';
import Plug from '../../components/Plug';
import PowerOceanA from '../../components/PowerOceanA';
import ProductListStatusB from '../../components/ProductListStatusB';
import SeamLess from '../../components/SeamLess';
import SectionB2 from '../../components/SectionB2';
import Assistant from '../../components/Assistant';
import SubscribeC from '../../components/SubscribeC';
import Certification from '../../components/Certification';
import CertificationBanner from '../../components/CertificationBanner';
import Spread from '../components/Spread';
import { useRouter } from 'next/router';
import ZeroBills from '../components/ZeroBills';
import EveryRoom from '../components/EveryRoom';
import BreakLimits from '../components/BreakLimits';
import BreakSpaceLimits from '../components/BreakSpaceLimits';
import LoopVideoSection from '../../components/LoopVideoSection';
import SectionListGraph from '../components/SectionListGraph';
import SectionGraphCompare from '../components/SectionGraphCompare';
import SectionCompare from '../components/SectionCompare';
import OnlineStoreRightsA5 from '../../components/OnlineStoreRightsA5';

export default function StatusItem() {
    const { locale = 'eu' } = useRouter();
    return (
        <>
            <BannerA1 />
            <CertificationBanner />
            <LoopVideoSection />
            <div className="product-box">
                {['eu', 'de'].includes(locale) ? <OnlineStoreRightsA5 /> : <OnlineStoreRightsA4 />}
                <EcoSpace hPc="160px" hPad="100px" hH5="100px" bgColor="#fefbf0" />
                {/* <OnlineStoreRightsNa /> */}
                <ProductListStatusB />
                <EcoSpace hPc="85px" hPad="45px" hH5="25px" />
                <SubscribeC />
                <EcoSpace hPc="160px" hPad="100px" />
                <BreakLimits />
                <ZeroBills />
                <BreakSpaceLimits type="A" />
                <EveryRoom />

                {locale !== 'uk' && <Plug pageType="normal" />}
                {/* <SectionB1 pageType="normal" /> */}
                <SectionB2 pageType="normal" />

                <BreakSpaceLimits type="B" />
                <Spread />

                <SectionListGraph />
                <SectionGraphCompare />
                <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
                <PathToZero />
                <div style={{ background: '#000' }}>
                    <EcoAi pageType="normal" />
                    <SeamLess pageType="normal" />
                    <Assistant pageType="normal" />
                </div>
                <Engineering />
                {/* <ProductContrast /> */}
                <EcoSpace hPc="160px" hPad="100px" />
                {/* <ChoosePlanModule /> */}
                <Certification />
                <EcoSpace hPc="160px" hPad="100px" hH5="0" />
                <SectionCompare />
                <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
                <PowerOceanA />
                <EcoSpace hPc="160px" hPad="100px" hH5="0" />
                <FooterTcA />
            </div>
        </>
    );
}
